import ErrorBoundary from '@/components/ErrorBoundary';
import { DefaultComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { getLabStylingClasses } from 'lib/utils/getLabStylingClasses';
import { TextTitle, TextTitleProps } from './TextTitle';

export interface StandaloneTextTitleProps extends StandaloneComponentProps {
  title: string;
  options?: Omit<TextTitleProps, 'title'>;
}

export const StandaloneTextTitle: StandaloneComponent<StandaloneTextTitleProps> = ({ title, options, ...props }) => {
  return (
    <ErrorBoundary>
      <TextTitle {...options} {...props}>
        {title}
      </TextTitle>
    </ErrorBoundary>
  );
};

export const standalone = StandaloneTextTitle;

const DefaultTextTitle: DefaultComponent = ({ type, meta, data }) => {
  const title = data.title;
  const titleStylingClasses = data.fieldSettings.title;
  const className = getLabStylingClasses(titleStylingClasses);
  return (
    <StandaloneTextTitle title={title} options={{ className: className }} {...withDebugMetadata({ type, meta })} />
  );
};

export default DefaultTextTitle;
